import { selectCustomerForm } from 'store/cartSlice/selectors';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import EventFieldSwitcher from './EventFieldSwitcher';
import LoadingSpinner from '../Common/LoadingSpinner';

const CustomerForm: React.FC<{}> = () => {
  const fields = useSelector(selectCustomerForm);
  const { t } = useTranslation();
  const sortedFields = fields
    ? [...fields].sort((a, b) => a.order - b.order)
    : [];

  return fields && fields.length > 0 ? (
    <div className="mt-[24px]">
      <h2 className="h2-semibold">
        {t('registrationPage.additionalInformationTitle')}
      </h2>
      <Suspense fallback={<LoadingSpinner />}>
        <div className="[&>div]:mt-[16px]">
          {sortedFields.map(field => (
            <EventFieldSwitcher
              inputName={`customer-${field.id}`}
              key={field.id}
              field={{
                ...field,
                label: field.label,
              }}
              disabled={false}
            />
          ))}
        </div>
      </Suspense>
    </div>
  ) : (
    <></>
  );
};

export default CustomerForm;
